module.exports = __webpack_public_path__ + "img/login-v2.73d7c2e8.png";